import MyProfile from "./routes/my-profile/MyProfile.tsx";
import Organization from "./routes/organization/Organization.tsx";
import Users from "./routes/users/Users.tsx";
import AdminEnvironmentVariables from "./routes/admin/AdminEnvironmentVariables.tsx";
import AuditLogsList from "./routes/audit-logs/AuditLogsList.tsx";
// #RoutesConfigImport
import { RoleEnum } from "./types/RoleEnum.ts";

export const routesConfig = {
  myProfile: {
    path: "/my-profile",
    component: MyProfile,
  },
  organizations: {
    path: "/organizations",
    component: Organization,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  users: {
    path: "/users",
    component: Users,
    roles: [RoleEnum.AGENCY_WORKER, RoleEnum.PUBLISHER_ADMIN, RoleEnum.ADMIN_LEGAL_DEPOSITS],
  },
  auditLogs: {
    path: "/audit-logs",
    component: AuditLogsList,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  adminEnvironmentVariables: {
    path: "/admin/environment-variables",
    component: AdminEnvironmentVariables,
    roles: [RoleEnum.SUPERUSER],
  },
  // #RoutesConfiguration
};